import CertsModal from './DriverCertificationsModal';
export { default as useDriverCertificationsModal } from './useDriverCertificationsModal';

export default CertsModal;
